import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../common/Spinner';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { Card, CardBody, Row, Col } from 'reactstrap';
import TitleHeader from '../common/TitleHeader';
import RowForTable from './components/TableRow';
import Paper from '@mui/material/Paper';
import StyledTableHeader from './components/TableHeaderStyle';
import DashBoardSearch from './components/DashBoardSearch';


export default function DashboardProjectPage(props) {
    const navigate = useNavigate();
    // store page loading state
    const [isLoading, setIsLoading] = useState(false);
    // store querystring params
    const [queryParams, setQueryParams] = useState(undefined);
    // const [sessionList, setSessionList] = useRef([]);
    const [showMyProductPrice, setShowMyProductPrice] = useState(false);
    const [showMSRPPrice, setShowMSRPPrice] = useState(true);
    const [showWholeSalePrice, setShowWholeSalePrice] = useState(true);
 

    const sessionListRef = useRef(null);
    const [filteredData, setFilteredData] = useState([]);

    const searchParam = useLocation().search;

    const getParamPreservePlus = (name) => {
        if (!searchParam) return null;
        const match = searchParam.match(new RegExp(`[?&]${name}=([^&#]*)`));
        if (!match) return null;
        const raw = match[1];
        try {
            // Replace '+' with '%2B' before decoding so '+' is preserved
            return decodeURIComponent(raw.replace(/\+/g, '%2B'));
        } catch (err) {
            return raw;
        }
    };

    const encryptedCustomerNo = getParamPreservePlus('c');
    const encryptedEmail    = getParamPreservePlus('e');
    const encryptedPricing = getParamPreservePlus('pr');
    const encryptedWarehouse = getParamPreservePlus('wh');
    const api_url = process.env.REACT_APP_SERVER_URL;
    const getSessionsList = async () => {
        try {
            setIsLoading(true); 
            let promises = [];

            const payload = {
                CustomerNo: getParamPreservePlus('c'),
                Email: getParamPreservePlus('e'),
                Currency: new URLSearchParams(searchParam).get('curr'),
                ConfigID: new URLSearchParams(searchParam).get('cID') || new URLSearchParams(searchParam).get('cId') || new URLSearchParams(searchParam).get('cid'),
                CloneID: new URLSearchParams(searchParam).get('cn'),
                ProductId: new URLSearchParams(searchParam).get('p'),
                Pricing: encryptedPricing,
                CanAddToCart: new URLSearchParams(searchParam).get('a')
            };
 

           //decrypt query params
           promises.push(
                axios.post(`${api_url}Product/Decrypt`, payload, {
                headers: { 'Content-Type': 'application/json' },
                })
            ); 
 
           promises.push(axios.get(`${api_url}Product/GetConfigurations?c=${encodeURIComponent(encryptedCustomerNo)}&e=${encodeURIComponent(encryptedEmail)}`));           
           await Promise.all(promises).then((responses) => {
                if (!responses[0]?.data || !responses[1]?.data) {
                    throw new Error('Invalid response data');
                }

                const queryParamData = responses[0].data;
                const defaultCurrency = queryParamData.currency ?? 'USD'; // default 'USD'
                const isPrMissingOrEmpty = (encryptedPricing === null) || (typeof encryptedPricing === 'string' && encryptedPricing.trim() === '');
                const defaultPricing = isPrMissingOrEmpty ? '0,0,0' : (queryParamData.pricing ?? '1,1,1'); // if no 'pr', disable all pricing
                const canAddToCart = queryParamData.canAddToCart?.toLowerCase() === "false" ? false : true
                const paramsData = {
                    ...queryParamData,
                    currency: defaultCurrency,
                    pricing: defaultPricing,
                    canAddToCart: canAddToCart
                };

               
                setQueryParams(paramsData);
                const data = responses[1].data;
                
                sessionListRef.current = data;
                  
                setFilteredData(data);

                checkPricingPermissions(defaultPricing);
                setIsLoading(false);
            });
            
        } catch (error) {
            setIsLoading(false);
            toast.error(`Failed to load configuration projects: ${error.message || 'Unknown error'}`);
            console.error('Error fetching configuration projects list:', error);
        }
    };
    useEffect(() => {

        getSessionsList();
    }, [encryptedCustomerNo]);

    // Add this flag at the top of your component
    let isNavigating = false;


   
    const deleteProject = async (encProjectId) =>{
        // encProjectId is typically a base64-ish token that may already be URL-encoded.
        // If we encode an already-encoded token, '%' becomes '%25' and the API won't find the project.
        const encodedId = (typeof encProjectId === 'string' && /%[0-9A-Fa-f]{2}/.test(encProjectId))
            ? encProjectId
            : encodeURIComponent(encProjectId);

        const url = `${api_url}Product/DeleteProject/${encodedId}`;

        try {
            // Dev environment returns 404 for the browser CORS preflight (OPTIONS) on this route,
            // which blocks any PUT from the UI. Using GET avoids preflight and matches how the
            // endpoint succeeds when invoked directly (browser/Postman URL).
            //
            // Long-term: fix the dev gateway/API CORS handling for OPTIONS+PUT, then switch back to PUT.
            const apiResponse = await axios.get(url);

            if(apiResponse.data === "success")
            {
                getSessionsList();
                toast.success("Project deleted successfully");
            }
            else
            {
                console.error('DeleteProject did not return success:', { url, data: apiResponse.data });
                toast.error("Failed to delete project");
            }
        } catch (error) {
            const status = error?.response?.status;
            const data = error?.response?.data;
            console.error('Error deleting project:', { url, status, data, error });
            toast.error(`Failed to delete project${status ? ` (HTTP ${status})` : ''}`);
        }
    };
    

    

    const downloadProject = async (encProjectId) => {
        // Make sure this function is called directly from a user click
      
        const response = await axios.get(
          `${api_url}Product/ExportProject?pid=${encodeURIComponent(encProjectId)}&pr=${encodeURIComponent(encryptedPricing)}`,
          
          {
            responseType: "blob",
            // You don't need Content-Type on a GET request
          }
        );
      
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      
        const downloadUrl = window.URL.createObjectURL(blob);
      
        const a = document.createElement("a");
        a.href = downloadUrl;
      
        // Generate the filename
        const filename = `JamesBySonance_Project_Export_${new Date()
          .toJSON()
          .slice(0, 10)}.xlsx`;
        a.download = filename;
      
        // ⬅️ This is important: add it to the DOM
        document.body.appendChild(a);
      
        // Trigger the download
        a.click();
      
        // Clean up
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      };
      

    // Change to non-async function
    const editRecord = (config) => {
        // Prevent recursive or duplicate calls
        if (isNavigating) {
            console.log("Navigation already in progress, ignoring call");
            return;
        }
        
     
        
        if (!config || !config.idConfig) {
            console.error("Invalid config object:", config);
            toast.error("Cannot edit this configuration: missing ID");
            return;
        }
        
        // Set flag to prevent multiple calls
        isNavigating = true;
        setIsLoading(true);
        
        // Use a regular promise chain instead of async/await
        axios.post(
            process.env.REACT_APP_SERVER_URL + 'Product/Encrypt',
            { ConfigID: config.idConfig.toString() },
            { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
            const data = response.data;
            
            // Create a simple string URL for return
            const dashboardUrl = `/dashboard?c=${encryptedCustomerNo}&e=${encryptedEmail}&wh=${encryptedWarehouse}&pr=${encryptedPricing}`;
            const returnUrl = encodeURIComponent(dashboardUrl);
            
            // Create a separate form and submit it programmatically
            const form = document.createElement('form');
            form.method = 'GET';
            form.action = '/productconfig';
            
            // Add hidden fields for parameters
            const addParam = (name, value) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = value;
                form.appendChild(input);
            };
            
            addParam('cID', data.configID);
            addParam('c', encryptedCustomerNo);
            addParam('e', encryptedEmail);
            addParam('wh', encryptedWarehouse);
            addParam('returnUrl', returnUrl);
            
            // Append form to body, submit, and remove
            document.body.appendChild(form);
            form.submit();
        })
        .catch(error => {
            isNavigating = false;
            setIsLoading(false);
            console.log('error fetching the product configuration', error);
            toast.error('Error fetching the product configuration.');
        });
    };

    const cloneRecord = (config) => {
        // Prevent recursive or duplicate calls
        if (isNavigating) {
            console.log("Navigation already in progress, ignoring call");
            return;
        }
        
        console.log("Clone record called with config:", config);
        
        if (!config || !config.idConfig) {
            console.error("Invalid config object:", config);
            toast.error("Cannot clone this configuration: missing ID");
            return;
        }
        
        // Set flag to prevent multiple calls
        isNavigating = true;
        setIsLoading(true);
        
        // Use a regular promise chain instead of async/await
        axios.post(
            process.env.REACT_APP_SERVER_URL + 'Product/Encrypt',
            { CloneID: config.idConfig.toString() },
            { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
            const data = response.data;
            
            // Create a simple string URL for return
            const dashboardUrl = `/dashboard?c=${encryptedCustomerNo}&e=${encryptedEmail}`;
            const returnUrl = encodeURIComponent(dashboardUrl);
            
            // Create a separate form and submit it programmatically
            const form = document.createElement('form');
            form.method = 'GET';
            form.action = '/productconfig';
            
            // Add hidden fields for parameters
            const addParam = (name, value) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = value;
                form.appendChild(input);
            };
            
            addParam('cn', data.cloneID);
            debugger;
            addParam('c', encryptedCustomerNo);
            addParam('e', encryptedEmail);
            addParam('wh', encryptedWarehouse);
            addParam('returnUrl', returnUrl);
            
            // Append form to body, submit, and remove
            document.body.appendChild(form);
            form.submit();
        })
        .catch(error => {
            isNavigating = false;
            setIsLoading(false);
            console.log('error fetching the product configuration', error);
            toast.error('Error fetching the product configuration.');
        });
    };

    const trashRecord = async (config) => {
        setIsLoading(true);
        try {
         
           await axios.post(
                process.env.REACT_APP_SERVER_URL + 'Product/DeleteConfig',
                {cId: config},
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );  
            
           await getSessionsList();
            toast.success('Configured Product deleted successfully.');
        } catch (error) {
            console.log('error deleting the product configuration', error);
            toast.error('Error deleting the product configuration.');
        } finally {
            setIsLoading(false);
        }
    }   

    const updateProjectStatus = (config, newValue) => {
        try {
            const payload = {
                Id: config.id,
                Status: newValue,
            };
            const apiResponse = axios.post(
                process.env.REACT_APP_SERVER_URL +
                    'Product/UpdateProjectStatus',
                payload,
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            toast.success('Project updated successfully.');
        } catch (error) {
            console.log('error saving the project', error);
            toast.error('Error saving the project.');
        }
    };

    const updateStatus = async (config, newValue) => {
        try {
            await axios.post(
                process.env.REACT_APP_SERVER_URL + 'Product/UpdateConfig',
                {
                    idConfig: config.idConfig,
                    Status: newValue,
                },
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            toast.success('Configuration saved successfully.');
        } catch (error) {
            console.log('error saving the product configuration', error);
            toast.error('Error saving the product configuration.');
        }
    };

    const searchList = async (configSearch) => {
        try {
            setIsLoading(true);
            const payload = {
                CustomerNumber: encryptedCustomerNo,
                Email: encryptedEmail,
                ProjectName: configSearch.projectName,
                Title: configSearch.title,
                SKU: configSearch.sku,
                FromDate: configSearch.startDate,
                ToDate: configSearch.endDate,
                Status: configSearch.status,
                CreatedBy: configSearch.user
            };
            const apiResponse = await axios.post(
                process.env.REACT_APP_SERVER_URL +
                    'Product/SearchConfigurations',
                payload,
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
           
            setFilteredData(apiResponse.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log('Error searching the list', error);
            toast.error('Error searching the list.');
        }
    };

    const clearSearchList = () => {
        try {
            setFilteredData(sessionListRef.current);
        } catch (error) {
            console.log('error searching the list', error);
            toast.error('Error searching the list.');
        }
    };

    function checkPricingPermissions(pricing)
    {

        if(pricing && pricing.length > 0)
        {
            var pf = pricing.split(",");
            if(pf.length === 3)    
            {
                setShowMyProductPrice(pf[2] === "1");
                setShowWholeSalePrice(pf[1] === "1");
                setShowMSRPPrice(pf[0] === "1");
            }
        }
        else{
            setShowMyProductPrice(false);
            setShowWholeSalePrice(false);
            setShowMSRPPrice(false);
        }
               
    }

    return (
        <div>
            <Card>
                
                    <TitleHeader show={false}></TitleHeader>
               
                <CardBody
                    style={{ minHeight: '85vh', backgroundColor: '#e9ecee' }}
                >
                    {isLoading && <Spinner />}
                    
                    <Row>
                        <Col>
                            <Card className='dashboardForm'>
                                <CardBody
                                    style={{
                                        backgroundColor: '#fffff',
                                        boxShadow:
                                            'rgba(0, 0, 0, 0.1) 0px 12px 24px 0px ',
                                    }}
                                >
                                    <Row>
                                        <DashBoardSearch
                                            searchList={searchList}
                                            clearSearchList={clearSearchList}
                                        ></DashBoardSearch>
                                    </Row>
                                    <Row>
                                        <TableContainer component={Paper}>
                                            <Table aria-label='collapsible table'>
                                                <TableHead>
                                                    <StyledTableHeader sx={{ '& .MuiTableCell-root': { fontSize: '13px' } }}>
                                                        <TableCell sx={{"width": "28%"}} colSpan={2}>Projects</TableCell>

                                                        <TableCell align='center'  sx={{"width": "9%"}}  >
                                                            Project Total
                                                        </TableCell>
                                                        <TableCell align='center' sx={{"width": "6%"}} >
                                                           Total Qty
                                                        </TableCell>
                                                        <TableCell  sx={{"width": "5%"}}>
                                                          Your Project Status
                                                        </TableCell>
                                                        <TableCell  sx={{"width": "20%" }}>
                                                            Project Created
                                                        </TableCell>
                                                        <TableCell sx={{"width": "35%"}}>
                                                             
                                                        </TableCell> 
                                                    </StyledTableHeader>
                                                </TableHead>
                                                {filteredData && (
                                                    <TableBody>
                                                        {filteredData.map(
                                                            (row) => (
                                                                <RowForTable
                                                                    updateStatus={
                                                                        updateStatus
                                                                    }
                                                                    editRecord={
                                                                        editRecord
                                                                    }
                                                                    cloneRecord={
                                                                        cloneRecord
                                                                    }
                                                                    updateProjectStatus={
                                                                        updateProjectStatus
                                                                    }
                                                                    trashRecord={
                                                                        trashRecord
                                                                    }
                                                                    downloadProject={downloadProject}
                                                                    deleteProject={deleteProject}
                                                                    key={row.id}
                                                                    row={row}
                                                                    user={queryParams.email}
                                                                    currency={queryParams.currency}
                                                                    showMSRP = {showMSRPPrice}
                                                                    showWholeSale= {showWholeSalePrice}
                                                                    showMyPrice={showMyProductPrice}
                                                                    showProjectTotal={(showMSRPPrice || showWholeSalePrice || showMyProductPrice)}
                                                                    pricingFlag={queryParams.pricing}
                                                                    canAddToCart={queryParams.canAddToCart}
                                                                />
                                                            )
                                                        )}
                                                    </TableBody>
                                                )}
                                            </Table>
                                        </TableContainer>
                                    </Row>
                                    <br />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}
